/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-shadow */

import fetch from 'isomorphic-fetch';
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Menu, MenuItem, AsyncTypeahead } from 'react-bootstrap-typeahead';
import authenticationService from '../../../authenticationService';
const $ = require('jquery');


const ItemSearchInput = (props) => {

    const ref = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        if (!props.disabled) {
            setIsLoading(true);
            setOptions([]);
            setIsLoading(false);
        }
    }, [props.disabled]);

    let enterPressed = false;
    let noResult = " No match found -";
    let isButtonPressed = false;
    let isSelected = false;

    const filterByCallback = (option, props) => (
        // support for item type
        option.type.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '').indexOf(props.text.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '')) !== -1 ||
        // support for comments
        option.other.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '').indexOf(props.text.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '')) !== -1 ||
        (!option.id && option.description == noResult) ||
        option.id.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '').indexOf(props.text.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '')) !== -1 ||
        option.description.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '').indexOf(props.text.toLowerCase().replace(/-|\s/g, "").replace(/\//g, '')) !== -1
    );

    const handleSearch = useCallback((query) => {

        let isOptionEmpty = options.length === 0 ||
            (!options[0].id && options[0].description == noResult);

        if ((enterPressed && query && isOptionEmpty) || (isButtonPressed && query)) {
            setIsLoading(true);

            fetch('/erp/OrderEntry/Items?searchString=' + encodeURI(query), {
                headers: {
                    'Authorization': authenticationService()
                }
            }).then((response) => {
                if (response.status !== 200)
                    throw new Error(response.status)
                return response.json()
            }).then((items) => {
                if (items.error) items = [];
                if (items) {

                    const options = (items).map((i) => ({
                        id: i.itemNo,
                        description: i.description,
                        other: i.other,
                        disabled: false,
                        type: i.itemType
                    }));
                    setOptions(options);

                    if (options.length == 0) {
                        setOptions([{
                            id: "", description: noResult, other: "", disabled: true, type: ""
                        }]);
                    }

                    setIsLoading(false);

                    if (ref && ref.current) {
                        ref.current.focus();
                        isButtonPressed = false;
                    }
                }
            });
        }
        enterPressed = false;
    });

    return (
        <div className='container-fluid'>
            <div className="row">
                {props.disabled ? (
                    <div className="col-10 position-relative" disabled>
                        <input className='rbt-input-main form-control rbt-input' disabled />
                    </div>
                ) : (
                        <AsyncTypeahead
                            id="inputbox"
                            className="col-10"
                            filterBy={filterByCallback}
                            ref={ref}
                            isLoading={isLoading}
                            labelKey="description"
                            onSearch={
                                (e) => {
                                    handleSearch(e);
                                }
                            }
                            promptText=""
                            flip={true}
                            highlightOnlyResult={true}
                            selectHintOnEnter={true}
                            onKeyDown={(e) => {
                                if (e.keyCode === 8) {
                                    setIsLoading(false);
                                    setOptions([]);
                                    //ref.current.clear();
                                    return false;
                                }
                                if (e.keyCode === 13) {
                                    enterPressed = true;
                                    handleSearch(e.target.value);
                                }
                            }}
                            onChange={(e) => {
                                if (!isSelected) {
                                    props.onChange(e);
                                    isSelected = true;
                                }
                            }}
                            placeholder={props.placeholder}
                            useCache={false}
                            options={options}
                            renderMenu={(filteredOptions, menuProps) => (
                                <Menu {...menuProps} emptyLabel="">
                                    {filteredOptions.map((option, index) => (
                                        <MenuItem
                                            disabled={option.disabled}
                                            key={option.id}
                                            option={option}
                                            position={index}>
                                            {option.id} - {option.description}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                        />
                    )}

                <span className="col-2 btn btn-primary teal" onClick={() => {
                    enterPressed = true;
                    isButtonPressed = true;
                    if (ref && ref.current) {
                        handleSearch(ref.current.getInput().value);
                    }
                }}><i className="fa fa-search"></i></span>
            </div>
        </div>
    );
};

export default ItemSearchInput;